import styled from 'styled-components';

interface SurveyPickerButtonProps {
  buttonText: string | undefined;
  onClick: () => void;
  disabled?: boolean;
}

export const SurveyPickerButton = ({ buttonText, onClick, disabled }: SurveyPickerButtonProps) => {
  return (
    <Button onClick={onClick} disabled={disabled}>
      <ButtonText>{buttonText}</ButtonText>
    </Button>
  );
};

const Button = styled.button<{ disabled?: boolean }>`
  min-width: 84px;
  max-height: 40px;

  display: flex;
  justify-content: center;
  align-items: center;

  padding: 16px;
  gap: 4px;

  border-radius: var(--radius-medium, 8px);
  background: var(--Light-Scheme-Monochrome-grey70, #a7a9b6);
  opacity: ${(props) => (props.disabled ? 0.3 : 1)};
  white-space: nowrap;
`;

const ButtonText = styled.span`
  color: var(--Light-Scheme-Monochrome-white, #fff);

  /* System/Medium/m-medium */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 85%; /* 11.9px */
`;
